/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/iframe-has-title */
// @ts-nocheck

import { useNavigate } from "react-router-dom";
import React, { useState } from "react";
import { Popup } from "./components";
import ReactPaginate from "react-paginate";
import { ReactUtils } from "utils";
import { LINK_VIDEO } from "constants/common";
import TheBanner from "layout/TheBanner/TheBanner";
import moment from "moment";
import { formatNumber, urlAssetsCustom } from "utils/common";
import CommingSoonCountDown from "components/commingsoon-count-down";
import TheFooter from "layout/TheFooter";
import Select from "react-select";
import { event, $ } from "jquery";
import TheButtonGuideJoin from "layout/TheButtonGuideJoin/TheBanner";
const PrizeView = (props) => {
  const navigate = useNavigate();
  const {
    listWinnerSecond,
    listWinnerSpecial,
    listPhaseSpecial,
    listPhaseSecond,
    listPhaseThree,
    pagesSecond,
    pagesSpecial,
    onChangePageSecond,
    onChangePageSpecial,
    onChangePrizeTypeSpecial,
    onChangePrizeTypeSecond,
    prizeTypeSpecial,
    prizeTypeSecond,
    onSearchCodeSpecial,
    onSearchCodeSecond,
    searchCodeSecond,
    searchCodeSpecial,
    setSearchCodeSpecial,
    setSearchCodeSecond,
    listWinnerSpeciaSwiper,
    pagesThree,
    listWinnerThree,
    listPicture,
    pageOffsetSecond,
    pageOffsetSpecial,
    prizeTypes,
    prizeTypeSelected,
    setPrizeTypeSelected,
    winners,
    onSearchWinner,
    onChangePrizeTypeSelected,
    totalPage,
    onChangePageWinner,
    offsetWinner,
    setOffsetWinner,
    remaining,
    isSearchPhone,
    onclearSearch,
  } = props;

  const handlePageChangeSecond = (event) => {
    onChangePageSecond(event.selected);
    console.log(event);
    // TODO Only change displayed selected page
    // when its content is loaded in useEffect.
    // props.setPageOffset(event.selected);
  };

  const handlePageChangeSpecial = (event) => {
    // onChangePageSpecial(event.selected);
    console.log(event);
    // TODO Only change displayed selected page
    // when its content is loaded in useEffect.
    // props.setPageOffset(event.selected);
    onChangePageWinner(event.selected);
    setOffsetWinner(event.selected);
  };

  return (
    <>
      <div className="bgr-dstt">
        <section className="prizes ">
          <div className="group-action container d-none">
            <div className="group-btn-inline">
              <button
                type="button"
                className="btn btn-warning btn-block"
                onClick={() => {
                  navigate("/");
                }}
              >
                <a href="#guide">HƯỚNG DẪN</a>
              </button>
              <button
                type="button"
                className="btn btn-primary btn-block"
                onClick={() => {
                  navigate("/");
                }}
              >
                {" "}
                <a href="#join-info">THAM GIA NGAY</a>{" "}
              </button>
            </div>
          </div>

          <div className="container">
            <img
              id="list-winners"
              className="name-table d-none-mb"
              src={urlAssetsCustom("assets/img/table-title-1.png")}
              alt=""
            />
            <img
              className="name-table d-none"
              src={urlAssetsCustom("assets/img/table-title-1-mb.png")}
              alt=""
              id="join-info"
            />
            <div className="videoWrapper">
              <iframe
                width="100%"
                height="100%"
                src={LINK_VIDEO}
                title="MUA HaoHao - Cơ hội trúng Gói mì Hảo Hảo bàng vàng 24K, Logo Hảo Hảo bằng vàng 24K và tài khoản điện thoại trị giá 100,000 đồng"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen
              ></iframe>
            </div>
            {remaining && remaining?.length > 0 && (
              <div className="list-gift">
                <ul>
                  {remaining?.length > 0 &&
                    remaining?.map((item, index) => {
                      return (
                        <li>
                          <div className="countPro">
                            Còn{" "}
                            <b>
                              {ReactUtils.formatNumber(item.Remaining)}{" "}
                              {item.Name}
                            </b>
                          </div>
                        </li>
                      );
                    })}
                </ul>
                <div className="line"></div>
              </div>
            )}

            <div className="table-sprize">
              <div className="box-flex">
                <div className="form-group">
                  <select
                    className="form-control"
                    id="prize_type"
                    value={prizeTypeSelected}
                    onChange={(event) => {
                      const selectedValue = event.target.value;
                      setPrizeTypeSelected(selectedValue);
                      onChangePrizeTypeSelected(selectedValue);
                    }}
                  >
                    {prizeTypes?.map((elm, index) => {
                      return <option value={elm.value}>{elm.label}</option>;
                    })}
                  </select>
                  {/* <Select
                    className={`form-control  `}
                    placeholder="Chọn"
                    isClearable={true}
                    options={prizeTypes}
                    value={prizeTypes.filter(
                      ({ city }) => city === prizeTypeSelected
                    )}
                    onChange={(e) => {
                      console.log(e);
                      setPrizeTypeSelected(e);
                      onChangePrizeTypeSelected(e);
                    }}
                    onMenuOpen={() => {
                      setPrizeTypeSelected(null);
                    }}
                    onMenuClose={() => {
                      setPrizeTypeSelected(prizeTypeSelected);
                    }}
                  /> */}
                </div>
                <div className="search-flex">
                  <div className="form-group">
                    <div className="form-field">
                      <img
                        src={urlAssetsCustom("assets/img/icon/close-input.png")}
                        alt="text-info "
                        className="clear-icon"
                        onClick={onclearSearch}
                      />
                      <input
                        type="tel"
                        className="form-control "
                        id="codeSpecial"
                        name="phone"
                        placeholder="Nhập số điện thoại hoặc mã dự thưởng"
                        min="0"
                        max="10"
                        maxLength={10}
                        inputMode="numeric"
                        value={searchCodeSpecial}
                        onKeyDown={(e) => {
                          if (e?.keyCode === 13) {
                            const el = document.querySelector("#codeSpecial");
                            if (el.value?.trim()?.length > 0) {
                              onSearchCodeSpecial(el.value);
                            }
                          }
                        }}
                        onChange={(e) => {
                          setSearchCodeSpecial(e?.target?.value);
                          if (e.target.value === "") {
                            onSearchCodeSpecial("", true);
                          }
                        }}
                      />
                    </div>
                  </div>

                  <div
                    onClick={(e) => {
                      const el = document.querySelector("#codeSpecial");
                      onSearchWinner(el.value);
                      e.stopPropagation();
                    }}
                    className="search-btn"
                  >
                    <a>
                      <img
                        src={urlAssetsCustom("assets/img/icon/search.svg")}
                      />
                      <span>Tìm kiếm</span>
                    </a>
                  </div>
                </div>
              </div>
              <div className="table-sprize-inner" id="table_data">
                <ul className="list-code">
                  <li>
                    <span>Số điện thoại</span>
                    <span>Tên quà</span>
                  </li>
                  <ul className="list-scroll">
                    {winners?.length > 0 ? (
                      winners?.map((item, index) => {
                        return (
                          <>
                            <li>
                              <span>{item?.phoneNumber}</span>
                              <span>{item?.reward}</span>
                            </li>
                          </>
                        );
                      })
                    ) : (
                      <div className="no-date">
                        <p>Chưa có dữ liệu...</p>
                      </div>
                    )}
                  </ul>
                </ul>
              </div>
              {winners?.length > 0 && (
                <ReactPaginate
                  previousLabel=""
                  nextLabel=""
                  pageClassName="page-item"
                  pageLinkClassName="page-link"
                  previousClassName="page-item"
                  previousLinkClassName="page-link"
                  nextClassName="page-item"
                  nextLinkClassName="page-link"
                  breakLabel="..."
                  breakClassName="page-item"
                  breakLinkClassName="page-link"
                  pageCount={totalPage || 0}
                  marginPagesDisplayed={1}
                  pageRangeDisplayed={2}
                  onPageChange={handlePageChangeSpecial}
                  containerClassName="pagination container"
                  activeClassName="active"
                  forcePage={offsetWinner}
                />
              )}
            </div>
            {winners?.length == 0 && <TheButtonGuideJoin />}
          </div>
        </section>
      </div>
    </>
  );
};
export default PrizeView;
